<template>
  <div class="all-whole">
    <navCom :navActive="navActive"></navCom>
    <div class="w clearfix">
      <!--左侧导航 start-->
      <user-nav :userNav="userNav"></user-nav>
      <!--左侧导航 end-->
      <!--右侧内容 start-->
      <div  class="user-main-right">
        <div data-v-7ae4f9c5="" class="user-order-nav">
          <a data-v-7ae4f9c5="" href="javascript:;" :class="{'info-active':infoNav==1}" @click="infoNavFun(1)" class="info-title" >直播</a>
        </div>
        <div class="user-main-list" v-show="infoNav==1">
          <calendar-com v-on:getTimeTable="getTimeTable"></calendar-com>
          <ul class="timetable-list">
            <li @click="listDetailFun(item.course_id)" v-for="(item,index) of timetable" :key="index">
              <div class="timetable-list-item-top">
                <span>课程编号：{{item.course_num}}</span>
              </div>
              <div class="timetable-list-item-bottom">
                <div class="name">
                  <span><img :src="item.course_pic" width="100%" height="100%"></span>
                  <div class="timetable-txt">
                    <h3>{{item.course_name}}</h3>
                    <p>直播课</p>
                  </div>
                </div>

                <div class="time">
                  <span>{{item.live_start_time}}至{{item.live_end_time}}</span>
                  <span></span>
                </div>

                <div class="status">
                  <p class="look-time-txt" >{{item.status}}</p>
                </div>

                <div class="teacher">
                  <span class="teacher-img"><img :src="item.teacher_info.teacher_pic" width="100%" height="100%"></span>
                  <p class="teacher-txt">教师：{{item.teacher_info.teacher_name}}</p>
                </div>
              </div>
            </li>
          </ul>
        </div>
      </div>
      <!--右侧内容 end-->
    </div>
    <footerCom></footerCom>
  </div>
</template>

<script>
  import calendarCom from '.././components/calendar'
  import UserNav from '.././components/user-nav.vue'
  import navCom from '../../components/welcome-nav'
  import footerCom from '../../components/foot'
  import tool from '../../assets/tjs/tool'

  export default {
    name: "user-timetable",
    components: {
      UserNav,
      calendarCom,
      navCom,
      footerCom
    },
    data(){
      return{
        navActive:3,
        userNav:6,
        infoNav:1,
        timetable:[],//课程列表
      }
    },
    methods: {
      listDetailFun(id){
        this.$router.push({
          path:'/user/Livedetail',
          query: {
            course_id: id
          }
        })
      },
      infoNavFun(e){
        this.infoNav=e
      },
      /*获取课程表数据*/
      getTimeTable:function (e) {
        console.log('父组件事件触发了',e)
        var uuid = document.cookie.match(new RegExp("(^| )"+'uuid'+"=([^;]*)(;|$)"));
        let data = {
          user_id: this.$store.state.uuid,
          date: e
        };
        tool.postData('Center_My_Course/getDateCourseList', data,(res)=>{
          console.log('课程表',res.data);
          this.timetable = res.data;
        })
      },
    },
    mounted(){
      // this.getTimeTable()
    },
  }
</script>

<style scoped>
  .w{
    width: 1200px;
    margin: 0 auto ;
  }
  .fl{
    float: left;
  }
  .fr{
    float: right;
  }
  .all-whole{
    background: #fbfbfb;
    height: 100%;
  }
  .info-active{
    border-bottom:2px solid #1a71ff;
  }
  .user-order-nav{
    height: 80px;
  }
  .user-main-right{
    width: 1000px;
    float: right;
    height: 1200px;
    background: #ffffff;
  }
  .info-title{
    width: 100%;
    height: 70px;
    line-height: 100px;
    box-sizing: border-box;
    font-size: 18px;
    color: #252525;
    margin-left: 24px;
    padding-bottom: 6px;
    font-weight: 500;
  }
  .timetable-list li{
    border: 1px solid #e3e3e3;
    margin:0 auto 30px;
    cursor: pointer;
    width: 954px;
    height: 213px;
  }
  .timetable-list-item-top{
    width: 100%;
    background: #f3f3f3;
    height: 48px;
    border-bottom: 1px solid #e3e3e3;
    padding: 0 15px;
    box-sizing: border-box;
    display: flex;
    justify-content: space-between;
  }
  .timetable-list-item-top span{
    font-size: 16px;
    color: #3a3a3a;
    font-weight: 500;
    line-height: 48px;
  }
  .timetable-list-item-top span:last-child{
    text-align: right;
  }
  .timetable-list-item-bottom{
    font-size: 0;
  }
  .timetable-list-item-bottom .name{
    width: 350px;
    height: 165px;
    display: inline-block;
    padding: 28px 15px;
    box-sizing: border-box;
    border-right: 1px solid #e3e3e3;
    vertical-align: top;
  }
  .timetable-list-item-bottom .name span{
    width: 99px;
    height: 99px;
    display: inline-block;
  }
  .timetable-txt{
    display: inline-block;
    vertical-align: top;
    margin-left: 15px;
  }
  .timetable-txt h3{
    color: #414141;
    font-size: 20px;
    font-weight: 700;
    line-height: 36px;
    margin-bottom: 15px;
    width:200px;
    overflow: hidden;
    white-space:nowrap;
    text-overflow:ellipsis;
  }
  .timetable-txt p{
    font-size: 16px;
    color: #8c8c8c;
  }
  .timetable-list-item-bottom .time{
    width: 216px;
    height: 165px;
    line-height: 165px;
    display: inline-block;
    border-right: 1px solid #e3e3e3;
    vertical-align: top;
    box-sizing: border-box;
    text-align: center;
    overflow: auto
  }
  .week-txt{
    font-size: 16px;
    color: #8c8c8c;
    margin-bottom: 13px;
  }
  .time-txt{
    font-size: 22px;
    color: #8c8c8c;
    margin-bottom: 13px;
  }
  .duration-txt{
    height: 34px;
    border: 1px solid #dfdfdf;
    display: block;
    margin: 0 auto;
    color: #b5b5b5;
    line-height: 34px;
    font-size: 16px;
    display: inline;
    padding: 3px 10px;
  }
  .timetable-list-item-bottom .state{
    width: 210px;
    height: 165px;
    display: inline-block;
    padding: 30px 0;
    box-sizing: border-box;
    border-right: 1px solid #e3e3e3;
    text-align: center;
    vertical-align: top;
  }
  .state-item1{
    font-size: 18px;
    font-weight: 700;
    margin-bottom: 20px;
  }
  .state-item2{
    color: #8c8c8c;
    font-size: 14px;
    margin-bottom: 15px;
    font-weight: 500;
  }
  .state-item3{
    color: #8c8c8c;
    font-size: 14px;
    font-weight: 500;
  }
  .state-item3 span{
    color: #e10000;
  }
  .timetable-list-item-bottom .teacher{
    width: 158px;
    height: 165px;
    display: inline-block;
    padding: 30px 0;
    box-sizing: border-box;
    text-align: center;
    vertical-align: top;
  }
  .teacher-img{
    width: 47px;
    height: 47px;
    border-radius: 50%;
    overflow: hidden;
    display: block;
    margin: 10px auto 0;
  }
  .teacher-txt{
    font-size: 16px;
    color: #8c8c8c;
    margin-top: 17px;
    text-align: center;
  }
  .timetable-list-item-bottom .time span{
    color: #8c8c8c;
    font-size: 16px;
    line-height: 40px;
    vertical-align: middle;
    display: inline-block;
  }
  .look-time-txt{
    color: #1a71ff;
    font-size: 16px;
    text-align: center;
    margin-bottom: 18px;
  }
  .timetable-list-item-bottom .status p{
    font-size: 16px;
    line-height: 165px;
  }
  .timetable-list-item-bottom .status{
    width: 220px;
    height: 165px;
    display: inline-block;
    text-align: center;
    border-right: 1px solid #e3e3e3;
    vertical-align: top;
  }
  .timetable-list{
    height: 725px;
    overflow-y: auto;
  }
</style>



// WEBPACK FOOTER //
// src/pages/user/user-timetable.vue